import dayjs from "dayjs";
export var formatDate = function (rawDate) {
    if (rawDate) {
        var date = new Date(rawDate);
        if (date < new Date(0)) {
            return '';
        }
        return new Intl.DateTimeFormat("en-GB", { dateStyle: 'short', timeStyle: 'short' }).format(date);
    }
    return '';
};
export var formatDateYearMonth = function (rawDate) {
    if (rawDate) {
        var date = new Date(rawDate);
        if (date < new Date(0)) {
            return '';
        }
        return dayjs(date).format('MMMM/YYYY');
    }
    return '';
};
export var formatDateWithSecond = function (rawDate) {
    if (rawDate) {
        var date = new Date(rawDate);
        if (date < new Date(0)) {
            return '';
        }
        return new Intl.DateTimeFormat("en-GB", { dateStyle: 'short', timeStyle: 'medium' }).format(date);
    }
    return '';
};
export var formatDateWithoutTime = function (rawDate) {
    if (rawDate) {
        var date = new Date(rawDate);
        if (date < new Date(0)) {
            return '';
        }
        return dayjs(date).format('DD/MM/YYYY');
    }
    return '';
};
var DayOnly = function (rawDate) {
    var parsedDate = dayjs(new Date(rawDate));
    // get only Year, Month and Day, ignore time and timezone
    return dayjs.utc("".concat(parsedDate.year(), "-").concat(parsedDate.month() + 1, "-").concat(parsedDate.date()), "YYYY-M-D");
};
export var StartOfDay = function (rawDate) {
    return DayOnly(rawDate).startOf("day").format("YYYY-MM-DD HH:mm:ss");
};
export var TodayStartOfDay = function () {
    return DayOnly(new Date()).startOf("day").format("YYYY-MM-DD HH:mm:ss");
};
export var EndOfDay = function (rawDate) {
    return DayOnly(rawDate).endOf("day").format("YYYY-MM-DD HH:mm:ss");
};
export var TodayEndOfDay = function () {
    return DayOnly(new Date()).endOf("day").format("YYYY-MM-DD HH:mm:ss");
};
